import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'

import { Box, Convert, InfoRed } from './../block/Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data, user, assets_path } = this.props

    return (
      <div
        className='bg-cover bg-center bg-no-repeat pb-[50px]'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container leading-none'>
          <SimpleHeader
            title={`Доставка`}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[8px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[8px] flex items-center justify-center gap-[7px]'>
              Доставка товаров
              <Box />
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mb-[15px]'>Осуществляется Курьерской службой по фактическому адресу, указанному Покупателем, при оформлении заказа.</div>
            <div className='text-[14px] font-normal text-[#00000099] mb-[15px]'>Доставка Товаров в пределах зоны доставки осуществляется в соответствии с режимом работы Продавца, указанным на Сайте.</div>
            <div className='text-[14px] font-normal text-[#00000099]'>Доставка осуществляется при условии заказа Товаров на сумму минимального заказа. Сумма минимального заказа и стоимость доставки определяется Продавцом в одностороннем порядке и указывается на Сайте.</div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[8px] flex items-center justify-center gap-[7px]'>
              Сроки доставки
              <Convert />
            </div>
            <div className='text-[14px] font-normal text-start text-[#00000099] mb-[15px] bg-[#F6F6F6] rounded-[15px] p-[15px] flex items-center justify-center gap-[7px]'>
              <div>Указанные на сайте и по телефону сроки доставки являются ориентировочными</div>
              <div className='flex-none'>
                <InfoRed />
              </div>
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mb-[15px]'>
              Реальные сроки доставки могут отклоняться в сторону уменьшения или увеличения по причинам, не зависящим от Продавца (в том числе, но не ограничиваясь следующими:
              <b>загруженность дорог, количество заказов на указанное время, погодные условия, несоблюдение времени поставки или приготовления Товара со стороны партнера, форс-мажорные обстоятельства, указанные в разделе 9 и прочее).</b>
            </div>
            <div className='text-[14px] font-normal text-[#00000099]'>При наличии вышеуказанных обстоятельств Продавец не считается просрочившим доставку.</div>
          </div>
          <div className='bg-[#5A91FF] rounded-[25px] p-[15px] text-white mt-[5px] text-center'>
            <div className='text-[18px] font-semibold'>Отмена заказа Покупателем</div>
            <div className='mt-[10px] text-[#FFFFFFAB] text-[14px]'>Возможна только до момента назначения курьера на доставку.</div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  assets_path: PropTypes.string
}

export default Main